import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';

export type ExcelValidationResult = {
  ok: boolean;
  errors: string[];
};

export const validateExcelDuplicates = async (
  file: File,
  headerMappings: { source: string; target: string }[],
  requiredTargets: string[] = ['Barcode']
): Promise<ExcelValidationResult> => {
  try {
    const buffer = await file.arrayBuffer();
    const wb = XLSX.read(buffer, { type: 'array' });
    const sheetName = wb.SheetNames[0];
    const ws = wb.Sheets[sheetName];
    const rows: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1, raw: false });

    if (!rows.length) {
      return { ok: false, errors: ['Excel file is empty.'] };
    }

    const headers = rows[0].map((h: any) => (h ?? '').toString().trim());
    const colMap: Record<string, number> = {};
    for (const m of headerMappings) {
      const idx = headers.findIndex(h => h === m.source);
      if (idx >= 0) {
        colMap[m.target] = idx;
      }
    }

    const errors: string[] = [];
    const seen: Record<string, Set<string>> = {};

    for (const target of requiredTargets) {
      if (colMap[target] == null) continue;
      seen[target] = new Set();
    }

    for (let i = 1; i < rows.length; i++) {
      for (const target of requiredTargets) {
        const colIdx = colMap[target];
        if (colIdx == null) continue;
        const val = (rows[i][colIdx] ?? '').toString().trim();
        if (!val) continue;
        if (seen[target].has(val)) {
          errors.push(`Duplicate ${target} found: "${val}" at row ${i + 1}`);
        } else {
          seen[target].add(val);
        }
      }
    }

    if (errors.length) {
      return { ok: false, errors };
    }
    return { ok: true, errors: [] };
  } catch (err: any) {
    console.error('Excel validation failed', err);
    return { ok: false, errors: ['Failed to validate Excel file.'] };
  }
};
